// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-container {
  text-align: center;
  margin-top: 130px;
}
.logo-container span.logo {
  display: block;
  height: 70px;
  background-image: url('oir-logo-denied.0572b64c852296a5.svg');
  background-position: 50%;
  background-repeat: no-repeat;
}
.access-denied {
  margin-top: 60px;
  text-align: center;
}
.explanation {
  margin-top: 35px;
  text-align: center;
}
.explanation p {
  font-family: 'Montserrat-Semibold', sans-serif;
  font-weight: 600;
  color: #444444;
  font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/access-denied/access-denied.component.less"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,iBAAA;AADJ;AADA;EAKQ,cAAA;EACA,YAAA;EACA,6DAAA;EACA,wBAAA;EACA,4BAAA;AADR;AAKA;EACI,gBAAA;EACA,kBAAA;AAHJ;AAMA;EACI,gBAAA;EACA,kBAAA;AAJJ;AAEA;EAKQ,8CAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAJR","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.logo-container {\n    text-align: center;\n    margin-top: 130px;\n\n    span.logo {\n        display: block;\n        height: 70px;\n        background-image: url('../../styles/img/oir-logo-denied.svg');\n        background-position: 50%;\n        background-repeat: no-repeat;\n    }\n}\n\n.access-denied {\n    margin-top: 60px;\n    text-align: center;\n}\n\n.explanation {\n    margin-top: 35px;\n    text-align: center;\n\n    p {\n        font-family: 'Montserrat-Semibold', sans-serif;\n        font-weight: 600;\n        color: @secondary-90;\n        font-size: 24px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
